import * as ngCore from '@angular/core'
import * as ngMatCore from '@angular/material/core'

import * as models from '../../../models'
import { Store } from '../../../store'
@ngCore.Component({
  selector: 'atn-ds-date-range-overlay-content-custom-ranges',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** @see {@link ngMatCore.DateAdapter} */
  private readonly _dateAdapter = ngCore.inject<ngMatCore.DateAdapter<Date>>(
    ngMatCore.DateAdapter,
  )

  /**
   * Converts {@link models.DateRange.Predefined} enum into an array
   */
  public readonly customRanges = models.DateRange.Predefined.ALL

  /** Handles user selection of a predefined date range. */
  public predefinedRangeClickHandler(rangeName: models.DateRange.Predefined) {
    const newRange = models.DateRange.Predefined.calculate(
      rangeName,
      this._dateAdapter,
    )
    this.store.patchState({ editingDateRange: newRange })
  }
}
